// Click-id query params ad platforms append to landing URLs: Meta's fbclid, Google's
// gclid and its gbraid/wbraid variants for iOS traffic, OpenAI's oppref for ChatGPT ads.
export const AD_CLICK_ID_PARAMS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'oppref']

/**
 * @param {string} search `location.search`, with or without the leading `?`
 * @returns {boolean}
 */
export function hasAdClickId(search) {
  const params = new URLSearchParams(search)

  return AD_CLICK_ID_PARAMS.some((name) => params.has(name))
}
